<ul class="menu-navigation">
  <li
    [class.menu-close]="!isMenuOpen"
    [class.menu-open]="isMenuOpen"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-button"
    routerLink="/home"
    routerLinkActive="active-list-item"
    data-testid="home-link"
  >
    <div class="icon-container">
      <app-icon phosphorClass="ph-house" tooltipText="Accueil"></app-icon>
    </div>
  </li>
  <li
    [class.menu-close]="!isMenuOpen"
    [class.menu-open]="isMenuOpen"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-button"
    routerLink="/home/contracts"
    routerLinkActive="active-list-item"
    data-testid="contract-link"
  >
    <div class="icon-container">
      <app-icon phosphorClass="ph-files" tooltipText="Contrats"></app-icon>
    </div>
  </li>
  <li
    [class.menu-close]="!isMenuOpen"
    [class.menu-open]="isMenuOpen"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-button"
    routerLink="/home/invoices"
    routerLinkActive="active-list-item"
    data-testid="invoice-link"
  >
    <div class="icon-container">
      <app-icon phosphorClass="ph-currency-eur" tooltipText="Factures"></app-icon>
    </div>
  </li>
  <li
    [class.menu-close]="!isMenuOpen"
    [class.menu-open]="isMenuOpen"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-button"
    routerLink="/home/alerts"
    routerLinkActive="active-list-item"
    data-testid="alert-link"
  >
    <div class="icon-container">
      <app-icon phosphorClass="ph-clipboard-text" tooltipText="Journal d'alertes"></app-icon>
    </div>
  </li>
  <li
    [class.menu-close]="!isMenuOpen"
    [class.menu-open]="isMenuOpen"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-button"
    routerLink="/home/import"
    routerLinkActive="active-list-item"
    data-testid="import-link"
  >
    <div class="icon-container">
      <app-icon phosphorClass="ph-export" tooltipText="Importer une facture"></app-icon>
    </div>
  </li>
  <li
    [class.menu-close]="!isMenuOpen"
    [class.menu-open]="isMenuOpen"
    [routerLinkActiveOptions]="{ exact: true }"
    class="menu-button"
    routerLink="/home/settings"
    routerLinkActive="active-list-item"
    data-testid="setting-link"
  >
    <div class="icon-container">
      <app-icon phosphorClass="ph-wrench" tooltipText="Paramétrage"></app-icon>
    </div>
  </li>
  <div class="menu-spacer"></div>
</ul>